const fieldTypesMappings = {
    text: TaskFormFieldTypeText,
    checkbox: TaskFormFieldTypeCheckbox,
    boolean: TaskFormFieldTypeBoolean,
    yesNo: TaskFormFieldTypeYesNo,
    date: TaskFormFieldTypeDate,
    time: TaskFormFieldTypeTime,
    decimal: TaskFormFieldTypeDecimal,
    number: TaskFormFieldTypeNumber,
    textArea: TaskFormFieldTypeTextArea,
    html: TaskFormFieldTypeHtml,
    textBox: TaskFormFieldTypeTextBox,
    select: TaskFormFieldTypeSelect,
    datagroup: TaskFormFieldTypeDatagroup,
    email: TaskFormFieldTypeEmail,
    birthday: TaskFormFieldTypeBirthday,
    gender: TaskFormFieldTypeGender,
    householdMember: TaskFormFieldTypeHouseholdMember,
    emailType: TaskFormFieldTypeEmailType,
    addressLocationCountry: TaskFormFieldTypeAddressCountry,
    addressLocationState: TaskFormFieldTypeAddressState,
    addressType: TaskFormFieldTypeAddressType,
    phoneDefault: TaskFormFieldTypePhoneDefault,
    phoneType: TaskFormFieldTypePhoneType,
    instantMessengerType: TaskFormFieldTypeInstantMessengerType,
    socialNetworkType: TaskFormFieldTypeSocialNetworkType,
};

const TaskField = React.memo(function TaskField(props){
    const {
        type,
        renderAs,
        required,
        label,
        name,
        placeholder,
        instructions,
        value,
        showCharacterCounter,
        isMulti,
        minLength,
        maxLength,
        buttons,
        ...rest
    } = props;

    let HtmlTag = 'label';
    if(_.includes(['boolean', 'yesNo'], type)){
        HtmlTag = 'div';
    }
    if(type === 'select' && _.includes(['radiogroup', 'checkboxgroup'], renderAs)){
        HtmlTag = 'div';
    }

    let characterCounter = null;
    if(_.includes(['text', 'textArea', 'html'], type) && showCharacterCounter){
        let invalid = false;
        if(minLength && _.size(value) < minLength){
            invalid = true;
        }
        if(maxLength && _.size(value) > maxLength){
            invalid = true;
        }
        characterCounter = (
            <div className={`counter ${invalid ? 'invalid' : ''}`}>
                <span className="current">Characters: {_.size(value)}</span>
                {Boolean(minLength) && <span className="min">Min: {minLength}</span>}
                {Boolean(maxLength) && <span className="max">Max: {maxLength}</span>}
            </div>
        );
    }

    const FieldTypeClass = fieldTypesMappings[type];
    let fieldTypeProps = {
        ...rest,
        renderAs,
        required,
        name,
        label,
        placeholder,
        value,
        isMulti,
        minLength,
        maxLength,
    };

    //useRenderDebug(`TaskField|${name}`, {props});

    return (
        <HtmlTag className={'react-form-field'} data-id={`field | ${isMulti ? 'multi' : 'single'} | ${name}`}>
            {Boolean(_.size(label)) &&
                <div className={`label ${required ? 'required' : ''}`} dangerouslySetInnerHTML={{__html: label}}/>
            }
            <div className="instructions-and-counter">
                {Boolean(_.size(instructions)) &&
                <div className={'instructions'} dangerouslySetInnerHTML={{__html: instructions}}/>
                }
                {characterCounter}
            </div>
            <div className={'field'}>
                <FieldTypeClass {...fieldTypeProps} />
                {buttons}
            </div>
        </HtmlTag>
    );
});
TaskField.propTypes = {
    type: PropTypes.oneOf(_.keys(fieldTypesMappings)).isRequired,
    required: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    instructions: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    boxLabel: PropTypes.string,
    showCharacterCounter: PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    minValue: PropTypes.any,
    maxValue: PropTypes.any,
    rows: PropTypes.number,
    step: PropTypes.number,
    buttons: PropTypes.array,
    renderAs: PropTypes.oneOf(['combo', 'multiselect', 'radiogroup', 'checkboxgroup']),
    idPath: PropTypes.string,
    displayPath: PropTypes.string,
    groupPath: PropTypes.string,
    emptyListText: PropTypes.string,
    datagroupAlias: PropTypes.string,
    datagroupParentAlias: PropTypes.string,
    parentFilterBy: PropTypes.string,
    orderBy: PropTypes.string,
    orderDirection: PropTypes.oneOf(['asc', 'desc']),
    columns: PropTypes.number,
    autoFlexColumns: PropTypes.bool,
    isMulti: PropTypes.bool,
    multiMin: PropTypes.number,
    multiMax: PropTypes.number,
    yesLabel: PropTypes.string,
    noLabel: PropTypes.string,
    showYesExplanation: PropTypes.bool,
    showNoExplanation: PropTypes.bool,
    yesExplanationLabel: PropTypes.string,
    noExplanationLabel: PropTypes.string,
    yesExplanationRequired: PropTypes.bool,
    noExplanationRequired: PropTypes.bool,
    yesMaxChars: PropTypes.number,
    noMaxChars: PropTypes.number,
    onChange: PropTypes.func,
};
TaskField.defaultProps = {
    required: false,
    name: null,
    label: null,
    placeholder: null,
    instructions: null,
    value: null,
    showCharacterCounter: false,
    minLength: null,
    maxLength: null,
    buttons: null,
    onChange: (name, value) => {},
};
TaskField.displayName = 'TaskField';